import { render } from "./PublicPerson.vue?vue&type=template&id=531280ee&scoped=true"
import script from "./PublicPerson.vue?vue&type=script&lang=js"
export * from "./PublicPerson.vue?vue&type=script&lang=js"

import "./PublicPerson.vue?vue&type=style&index=0&id=531280ee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531280ee"]])

export default __exports__